/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamInvitationSummary
 */
export interface TeamInvitationSummary {
    /**
     * 
     * @type {string}
     * @memberof TeamInvitationSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamInvitationSummary
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamInvitationSummary
     */
    invitedUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamInvitationSummary
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof TeamInvitationSummary
     */
    expiresAt?: Date;
}

/**
 * Check if a given object implements the TeamInvitationSummary interface.
 */
export function instanceOfTeamInvitationSummary(value: object): value is TeamInvitationSummary {
    return true;
}

export function TeamInvitationSummaryFromJSON(json: any): TeamInvitationSummary {
    return TeamInvitationSummaryFromJSONTyped(json, false);
}

export function TeamInvitationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamInvitationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'invitedUserId': json['invitedUserId'] == null ? undefined : json['invitedUserId'],
        'status': json['status'] == null ? undefined : json['status'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

export function TeamInvitationSummaryToJSON(json: any): TeamInvitationSummary {
    return TeamInvitationSummaryToJSONTyped(json, false);
}

export function TeamInvitationSummaryToJSONTyped(value?: TeamInvitationSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'teamId': value['teamId'],
        'invitedUserId': value['invitedUserId'],
        'status': value['status'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
    };
}

